<template>
  <div>
    <v-multiselect
      :show-labels="false"
      :options="options"
      placeholder="Tapez pour rechercher"
      track-by="id"
      label="search"
      open-direction="bottom"
      :value="value"
      @select="onSelect"
      @open="onOpen"
      @close="onClose"
    >
      <template slot="option" slot-scope="props">
        <div class="select-option-main d-flex align-items-center">
          <span class="mr-2">
            {{ props.option.name }}
          </span>

          <appBOTantiemes :building-owner-data="props.option" />
        </div>
        <div class="select-option-description">
          {{
            props.option.building_lots ? props.option.building_lots.map(x => x.name).join(", ") : ""
          }}
        </div>
      </template>
      <span slot="noResult" class="mx-2">
        Oops! Aucun élément trouvé. Pensez à modifier la requête de recherche.
      </span>
    </v-multiselect>
  </div>
</template>

<script>
import appBOTantiemes from "@/components/snippets/BuildingOwnerTantiemes";

export default {
  components: {
    appBOTantiemes,
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    onSelect(e) {
      this.$emit("onSelect", e);
    },
    onOpen() {
      this.$emit("onOpen");
    },
    onClose() {
      this.$emit("onClose");
    },
  },
};
</script>
